import { OmniaConfig } from "../../config";
import { IOmniaHttpService, IOmniaSession } from "../../types";
import { defineDirective } from "../../utils/angular";

/** @internal */
export class LoginLinkCtrl {

    static create(): ng.IDirective {

        return defineDirective(LoginLinkCtrl, "shared/main/link/link.html");

    }

    static $inject = ["OmniaSession", "OmniaHttpService", "omniaConfig"]

    option: boolean
    sent = false
    error = false

    constructor(
        private readonly session: IOmniaSession,
        private readonly ohttp: IOmniaHttpService,
        config: OmniaConfig,
        private readonly baseUrl = config.baseUrl,
        public readonly email = session.loginLinkUser) {
    }

    canCommit() {
        return (this.option !== undefined) && (!this.sent)
    }

    redirectSignUp() {
        const url = `${this.baseUrl}/start/signup`
        window.location.replace(url)
    }

    redirectResetPwd() {
        const url = `${this.baseUrl}/#/?resetPassword`
        window.location.replace(url)
        window.location.reload()
    }

    commit() {

        if (!this.option) {
            this.session.logout()
        }

        if (this.option) {

            const url = `/api/user/v1/login/reset?token=${this.session.loginLinkToken}`

            this.ohttp
                .post(url)
                .then(() => {
                    this.sent = true
                    this.error = false
                })
                .catch(() => {
                    this.sent = false
                    this.error = true
                })

        }

    }

}

